"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onBrowserWrapRootElement = onBrowserWrapRootElement;
var tslib_1 = require("tslib");
var React = require("react");
var hook_context_1 = require("../hook-context");
var hook_runner_1 = require("../hook-runner");
function onBrowserWrapRootElement(plugins, context) {
  return tslib_1.__awaiter(this, void 0, void 0, function () {
    var appData, _a, getAppData, setAppData, RootElementInner, root, getRootElement, setRootElement, hookArgs;
    return tslib_1.__generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          appData = context.appData;
          _a = (0, hook_context_1.buildAppData)(appData), getAppData = _a.getAppData, setAppData = _a.setAppData;
          RootElementInner = function (_a) {
            var children = _a.children;
            return React.createElement(React.Fragment, null, children || null);
          };
          RootElementInner.displayName = 'RootElementInner';
          root = RootElementInner;
          getRootElement = function () {
            return root;
          };
          setRootElement = function (hoc) {
            var prevRoot = root;
            var newRoot = hoc(prevRoot);
            root = newRoot;
            return root;
          };
          hookArgs = (0, hook_context_1.buildHookContext)('onWrapRootElement', tslib_1.__assign(tslib_1.__assign({}, context), {
            getAppData: getAppData,
            setAppData: setAppData,
            getRootElement: getRootElement,
            setRootElement: setRootElement
          }));
          return [4 /*yield*/, (0, hook_runner_1.runHook)(plugins, 'onBrowserWrapRootElement', hookArgs)];
        case 1:
          _b.sent();
          return [2 /*return*/, {
            appData: getAppData(),
            result: {
              RootElement: getRootElement()
            }
          }];
      }
    });
  });
}